export const getArrayOfMapValues = () => {
    let values = [];
    let taskToDo = [];
    let divTaskType = document.querySelectorAll(".divTaskType");
    let divTaskToDo;
    for (let i = 0; i < divTaskType.length; i++) {
        taskToDo = [];
        divTaskToDo = document.querySelectorAll(".divTaskType-" + i + " .arrayStringValue input");
        for (const taskInput of divTaskToDo) {
            taskToDo.push(taskInput.value);
        }
        values.push({
            "type": document.querySelector(".divTaskType-" + i + " .configType").value, "settings":
            {
                "required_end_photo": { "value": document.querySelector(".divTaskType-" + i + " .required_end_photo").value, "type": "BOOLEAN" },
                "required_signature": { "value": document.querySelector(".divTaskType-" + i + " .required_signature").value, "type": "BOOLEAN" },
                "required_start_photo": { "value": document.querySelector(".divTaskType-" + i + " .required_start_photo").value, "type": "BOOLEAN" },
                "on_demand": { "value": document.querySelector(".divTaskType-" + i + " .on_demand").value, "type": "BOOLEAN" },
                "standard_duration": { "value": document.querySelector(".divTaskType-" + i + " .standard_duration").value, "type": "numeric" },
                "tasks_to_do": { "value": taskToDo, "type": "ARRAY_STRING" }
            }
        })
    }
    return values;
}
